import { combineReducers } from 'redux';

import selectedUserMetadataState, { selectedUserMetadataInitialState } from './metadata';
import selectedUserRolesState, { selectedUserRolesInitialState } from './roles';
import selectedUserSettingsState, { selectedUserSettingsInitialState } from './settings';
import selectedUserDetailsState, { selectedUserDetailsInitialState } from './userDetails';

export const selectedUserInitialState =  { 
  selectedUserDetailsState: selectedUserDetailsInitialState,
  selectedUserMetadataState: selectedUserMetadataInitialState,
  selectedUserRolesState: selectedUserRolesInitialState,
  selectedUserSettingsState: selectedUserSettingsInitialState
}

export default combineReducers({ 
  selectedUserDetailsState,
  selectedUserMetadataState,
  selectedUserRolesState,
  selectedUserSettingsState
})